import Icon from '../components/Icon.vue'

Icon.register({
  'arrow-circle-up': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M8 256c0-137 111-248 248-248s248 111 248 248-111 248-248 248-248-111-248-248zM151.6 284.9l72.4-75.5v182.6c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-182.6l72.4 75.5c9.3 9.7 24.8 9.9 34.3 0.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9l-132.6-132.7c-9.4-9.4-24.6-9.4-33.9 0l-132.8 132.7c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-0.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-circle-up.js
// module id = 619
// module chunks = 0